import { jsx as _jsx } from "react/jsx-runtime";
import { withStyle } from 'styletron-react';
import { StyledPositionLayoutBase, positionLayoutBasePropsToStyledProps, } from './PositionLayoutBase';
const StyledAbsoluteContainer = withStyle(StyledPositionLayoutBase, {
    position: 'absolute',
});
export const AbsoluteContainer = ({ children, ...positionLayoutBaseProps }) => {
    return (_jsx(StyledAbsoluteContainer, { ...positionLayoutBasePropsToStyledProps(positionLayoutBaseProps), children: children }));
};
